import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import download from "downloadjs";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";

interface IGetStatisticsExcel {
    from?: string;
    to?: string;
    group_id?: any;
    page?: number;
}


export const getStatisticsExcel = createAsyncThunk(
    "statistics/getStatisticsExcel",
    async ({from, to, group_id,page}: IGetStatisticsExcel, thunkAPI) => {

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }

            const {token} = JSON.parse(authToken);


            const params = createRequestParams(from, to, page, group_id);

            const response = await axios.get(`/api/statistics/report`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
                params,
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            download(response.data, "file.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

            return response.data;
        } catch (error) {
            // Handle the error
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

